import * as React from "react";
import axios from "axios";
import { Popover, Button, Chip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import * as settings from "../../settings";

export default function TrashPlan(props) {
  const updateFunc = props.updateFunc;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  function handleClick(e) {
    setAnchorEl(e.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleDelete(e) {
    axios
      .put(`${settings.API_SERVER}/api/plan_detail/${props.id}/`, {
        trash: true,
      })
      .then((res) => {
        console.log(res);
        updateFunc();
      })
      .catch((error) => console.log(error));
    handleClose();
  }

  return (
    <>
      <Chip
        label="Trash"
        variant="outlined"
        onDelete={(e) => {
          handleClick(e);
        }}
        color="primary"
        deleteIcon={<DeleteIcon />}
      />
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose}>
        <Button
          onClick={handleDelete}
          color="warning"
          sx={{ p: "0.5", borderRadius: "0.5rem" }}
          variant="contained"
        >
          <strong>Move plan to trash</strong>
        </Button>
      </Popover>
    </>
  );
}
